import { stripSensitive } from '@/plugins/flareSanitize'
import { flare } from '@flareapp/js'
import { flareVue } from '@flareapp/vue'

// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
	flare.light()
	// AAR-2041: never send cookies (they carry the access/refresh token).
	flare.configure({ beforeSubmit: (report) => stripSensitive(report) })
}

export { flare, flareVue }
